export default __webpack_public_path__ + "static/media/EY-MainRoom.36405a2c.jpg";